import Immutable from 'immutable';
import { RawSheet, Sheet } from 'records/Sheet';

export interface RawMapPunchList {
  type: string;
  sheets: RawSheet[];
  containerStyles: React.CSSProperties;
  resetPunchQuery: boolean;
}

export interface ViewMapPunchListData {
  type: string;
  sheets: Immutable.List<Sheet>;
  containerStyles: React.CSSProperties;
  resetPunchQuery: boolean;
}

const defaultValues: ViewMapPunchListData = {
  type: 'ViewMapPunchList',
  sheets: Immutable.List(),
  containerStyles: {},
  resetPunchQuery: true,
};

export const ViewMapPunchListFactory = Immutable.Record(
  defaultValues,
  'ViewMapPunchList'
);

export class ViewMapPunchList extends ViewMapPunchListFactory {
  serialize(): RawMapPunchList {
    return this.toJS();
  }

  static deserialize(rawViewMapPunchList: RawMapPunchList): ViewMapPunchList {
    return new ViewMapPunchList({
      ...rawViewMapPunchList,
      sheets: Immutable.List<Sheet>(
        rawViewMapPunchList.sheets.map(Sheet.deserialize)
      ),
    });
  }
}
